/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_State_Select_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a new state" |
*
* @param {Explorer_Info_State_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_select_placeholder = /** @type {((inputs?: Explorer_Info_State_Select_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Select_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner un nouvel etat")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen neuen Bundesstaat aus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un nuovo stato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите новый штат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un nuevo estado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择一个新的州")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい州を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक नया राज्य चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um novo estado")
	return /** @type {LocalizedString} */ ("Select a new state")
});